import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { ShieldCheck } from "lucide-react";
import { afterLogin } from "@/lib/authDestination";

export default function Consent() {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const [checks, setChecks] = useState({ share: false, health: false, withdraw: false });
  const all = checks.share && checks.health && checks.withdraw;

  const accept = async () => {
    const res = await api.post("/auth/consent", { accepted: true });
    setUser(res.data);
    navigate(afterLogin(res.data), { replace: true });
  };

  const Item = ({ id, label }) => (
    <label className="flex gap-3 items-start border border-border p-4 cursor-pointer select-none" data-testid={`consent-${id}`}>
      <input type="checkbox" checked={checks[id]} onChange={(e) => setChecks({ ...checks, [id]: e.target.checked })} className="mt-1 accent-black" />
      <span className="text-sm leading-snug text-muted-foreground">{label}</span>
    </label>
  );

  return (
    <div className="min-h-screen bg-background text-foreground flex items-center justify-center p-8">
      <div className="w-full max-w-lg">
        <ShieldCheck className="w-8 h-8 mb-4" strokeWidth={2} />
        <p className="text-xs tracking-[0.2em] uppercase font-bold text-muted-foreground">Athlete Data-Sharing Consent</p>
        <h1 className="font-heading text-3xl font-black tracking-tight mt-2 mb-6">Your consent, your control</h1>
        <div className="space-y-3">
          <Item id="share" label="I consent to sharing my training, performance and wearable data with authorised coaches and academy admins." />
          <Item id="health" label="I consent to processing of sensitive health data (injury, medical notes) strictly for my performance and safety, under India's DPDP Act, 2023." />
          <Item id="withdraw" label="I understand I may withdraw consent at any time. Archived clinical records remain private and are not shared by changing staff roles." />
        </div>
        <button
          data-testid="accept-consent-btn"
          onClick={accept}
          disabled={!all}
          className="w-full mt-6 bg-foreground text-background font-medium py-3.5 transition-colors hover:bg-neutral-800 disabled:opacity-30 disabled:cursor-not-allowed"
        >
          Accept & Continue
        </button>
      </div>
    </div>
  );
}
